import { type KPIScoreLimit, Score } from 'components/KPICard'

export const CSAT_RANGE_DESCRIPTION = `Needs work = 0 - 2.9
Fair = 3 - 3.9
Good = 4 - 4.8
Excellent = 4.9 - 5`

export const KPI_SCORES: KPIScoreLimit[] = [
  { max: 2.9, score: Score.NeedsWork },
  { max: 3.9, score: Score.Fair },
  { max: 4.8, score: Score.Good },
  { max: 5, score: Score.Excellent },
]
